<template>
    <el-card class="notice_matter common_matter" shadow="never">
        <div class="title">
            <p>通知消息</p>
        </div>
        <div class="notice_matter--con" v-loading="loading">
            <div v-if="noticeMsg.length==0" class="no_message">
                <img src="@/assets/images/empty.png" alt="">
                <p>暂无数据</p>
            </div>
            <template v-else>
                <div class="item">
                    <div>
                        <p class="con">
                            <span class="project_default" :class="setProjectClass('GC')">工程建设</span>
                            02-02 13:00  关于[某某项目][某某节点]的催办的催办的催办的催办的催办
                        </p>
                    </div>
                    <el-button type="text" size="mini" @click="noticeMsgCancel">忽略</el-button>
                </div>
                <div class="item">
                    <div>
                        <p class="con">
                            <span class="project_default" :class="setProjectClass('GC')">工程建设</span>
                            02-02 13:00  关于[某某项目][某某节点]的催办的催办的催办的催办的催办
                        </p>
                    </div>
                    <el-button type="text" size="mini" @click="noticeMsgCancel">忽略</el-button>
                </div>
                <div class="item">
                    <div>
                        <p class="con">
                            <span class="project_default" :class="setProjectClass('GC')">工程建设</span>
                            02-02 13:00  关于[某某项目][某某节点]的催办的催办的催办的催办的催办
                        </p>
                    </div>
                    <el-button type="text" size="mini" @click="noticeMsgCancel">忽略</el-button>
                </div>
                <div class="item">
                    <div>
                        <p class="con">
                            <span class="project_default" :class="setProjectClass('GC')">工程建设</span>
                            02-02 13:00  关于[某某项目][某某节点]的催办的催办的催办的催办的催办
                        </p>
                    </div>
                    <el-button type="text" size="mini" @click="noticeMsgCancel">忽略</el-button>
                </div>
                <div class="item">
                    <div>
                        <p class="con">
                            <span class="project_default" :class="setProjectClass('GC')">工程建设</span>
                            02-02 13:00  关于[某某项目][某某节点]的催办的催办的催办的催办的催办
                        </p>
                    </div>
                    <el-button type="text" size="mini" @click="noticeMsgCancel">忽略</el-button>
                </div>
                <div class="more" v-if="totalPage>page">
                    <el-button class="btn" @click="moreFn">加载更多...</el-button>
                </div>
            </template>
        </div>
    </el-card>
</template>

<script>
import {apiMessagegetExceptTaskList,apiurgeconfirmsaveBylist} from '@/server/msg.js';
export default {
    data(){
        return {
            loading:false,
            noticeMsg:[{}],
            totalPage:1,
            total:0,
            page:1
        }
    },
    created(){},
    methods:{
        fetchData(){//获取数据
            this.loading=true;
            apiMessagegetExceptTaskList({
                page:this.page,
                rows:20,
				filter:{
					readType:2,
					confirmType: 0
				}
            }).then(({data})=>{
                this.noticeMsg=this.noticeMsg.concat(data.rows)||[];
                this.totalPage=data.totalPageCount;
            }).finally(()=>{this.loading=false})
        },
        moreFn(){//加载更多按钮
            this.page=this.page+1;
			this.fetchData();
        },
        noticeMsgCancel(arg){//忽略按钮
            this.$confirm('是否忽略该消息？','提示',{
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(()=>{
                apiurgeconfirmsaveBylist({
					saveType:1,
					taskVoList:[arg]
				}).then(({data})=>{
					if(data.code=='1'){
						this.$message.success('操作成功');
						this.noticeMsg=[];
						this.page=1;
						this.fetchData();
					}else{
						this.$message.error(data.msg);
					}
				})
            }).catch(()=>{})
        },
        setProjectClass(value){
			let temp={
				'GC':'project_GC',
				'CG':'project_CG',
				'CQ':'project_CQ',
				'GT':'project_GT',
				'QT':'project_QT'
			}
			return temp[value];
		},
    }
}
</script>

<style lang="less" scoped>
.notice_matter{
    height: 100%;
    /deep/ .el-card__body{
        height: 100%;
    }
    .notice_matter--con{
        height: calc(100% - 50px);
        padding: 10px 20px 20px;
        .no_message{
            width: 100%;
            height: 100%;
            text-align: center;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            p{
                margin-top: 10px;
                color: rgba(0, 0, 0, 0.65);
                font-weight: 400;
                margin-right: 15px;
            }
        }
        .item{
            font-size: 14px;
            height: 50px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-bottom: 1px dashed #eee;
            >div{
                width: calc(100% - 50px);
                line-height: 1.5;
            }
            .con{
                width: 100%;
                display: inline-block;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
            .project_default{
                display: inline-block;
                border-radius: 3px;
                padding: 8px 10px;
                font-size: 12px;
                line-height: 12px;
                margin-right: 6px;
            }
        }
    }
}
</style>